<script>
import BTableSimple from './BTableSimple.vue'
import {
  TABLE_ACTIONS,
  TABLE_HEADERS,
} from '@/views/FormTemplates/table-headers'


export default {
  name: 'BTableFormTemplates',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
